<div class="app-container">
<!--  <header>-->
<!--    <h1>-->
<!--        SISU Foto-->
<!--    </h1>-->
<!--  </header>-->
  <main>
      <app-header></app-header>
      <router-outlet></router-outlet>
      <app-cookie-consent></app-cookie-consent>
  </main>
<!--  <footer>-->
<!--    <p>© SISU Foto - Anders Rostgaard Bystrup</p>-->
<!--  </footer>-->
</div>
